module.exports = __webpack_public_path__ + "img/case-bg.04343986.png";